import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LoaderService } from '@mtgame/ui';
import { RugbyGameApi, Game, handleError, ConfigService } from '@mtgame/core';

@Component({
  selector: 'mtg-rugby-game-documents',
  templateUrl: './rugby-game-documents.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RugbyGameDocumentsComponent {
  @Input()
  game: Game;

  constructor(
    private loaderService: LoaderService,
    private rugbyGameApi: RugbyGameApi,
    private configService: ConfigService,
  ) {
  }

  printApplication(type: 'game_user'|'tournament_user'): void {
    window.open(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${this.game.id}/game_application/?file_type=html&application_type=${type}`);
  }

  async downloadProtocol(): Promise<void> {
    this.loaderService.show();
    try {
      const response = await this.rugbyGameApi.downloadProtocol(this.game.id);
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(response);
      a.href = url;
      a.download = `Протокол ${this.game.team.name} - ${this.game.competitorTeam.name}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      handleError(e);
    } finally {
      this.loaderService.hide();
    }
  }
}
